import { Link } from 'react-router-dom';

import { ProductNavigation } from '../components/ui/ProductNavigation';
import styles from './ProjectsPage.module.css';

export function ProjectsPage() {
  return <main className={styles.page}>
    <ProductNavigation />
    <section className={styles.content}>
      <h1>欢迎光临w1</h1>
      <Link className={styles.componentsLink} to="/components">查看组件预览</Link>
    </section>
  </main>;
}
